import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "events",
  initialState: {
    list: [],
    count: 0,
  },
  reducers: {
    setEventsByUser: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },
    countEvents: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
  },
});

export const { setEventsByUser, countEvents } = slice.actions;

export default slice.reducer;

export const getEventsByUserSelector = (store) => store.events?.list || [];
export const getEventsCountSelector = (store) => store.events?.count || 0;